import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { patchCurrentUser } from 'src/state/users'
import { formatAddress, UserPatchType } from '@meniudigital/shared'
import Button from 'src/global/Button'
import { GoogleMap, OverlayView } from '@react-google-maps/api'
import { useNavigate } from 'react-router-dom'
import { Screen } from 'src/screens'
import { DEFAULT_LOGO_URL } from 'src/global/Header/TopRightDropdown'
import Setting from '../Setting'

export default function LocationSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)
  const navigate = useNavigate()

  if (!user) {
    return null
  }

  const { coords, logoUrl, name } = user

  const goToLocationPicker = () => {
    window.hideSettingsModal()
    navigate(Screen.SetLocation)
  }

  const toggleCoords = () => {
    dispatch(
      patchCurrentUser({
        type: UserPatchType.Location,
        data: { ...(coords || {}), isVisible: !coords?.isVisible },
      } as any),
    )
  }

  const hasCoords = Boolean(coords?.latitude && coords?.longitude)

  return (
    <Setting
      title="Locația Restaurantului"
      iconPath="/icons/location.png"
      isEnabled={coords?.isVisible}
      onToggle={toggleCoords}
      body={
        <>
          {hasCoords && (
            <GoogleMap
              mapContainerClassName="map-container"
              center={{ lat: coords!.latitude, lng: coords!.longitude }}
              zoom={17}
              options={{
                gestureHandling: 'none',
                mapTypeControl: false,
                fullscreenControl: false,
              }}
            >
              <OverlayView
                position={{ lat: coords?.latitude!, lng: coords?.longitude! }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              >
                <div className="client-marker-wrapper">
                  <div className="client-marker">
                    <img loading="lazy" src={logoUrl || DEFAULT_LOGO_URL} alt="Restaurant logo" className="client-logo" />
                    <span className="client-name">{name}</span>
                  </div>
                </div>
              </OverlayView>
              {coords?.addressObject && <div className="address-container">{formatAddress(coords?.addressObject)}</div>}
            </GoogleMap>
          )}
          <Button
            variant="as-text"
            text={hasCoords ? 'Schimbă locația...' : 'Alege locația exactă...'}
            onClick={goToLocationPicker}
          />
        </>
      }
    />
  )
}
